export const OwnerDocumentType = {
    GENERAL_CONDITIONS: "general_conditions",
    SPA_CONDITIONS: "spa_conditions",
    OTHER: "other",
};
